import type { App } from 'vue'
import { hasPermission } from '@/vue/composables/use-has-permission'

// @ts-expect-error baseline
declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $hasPermission: typeof hasPermission
    }
}

export default {
    install: (app: App): void => {
        // @ts-expect-error baseline
        app.config.globalProperties.$hasPermission = hasPermission
    },
}
